import { ProductDto, ProductDtoAttributes } from "../Product"
import { InventoryData } from "../../inventory/data/model/inventoryData"

export const ACTION_TYPES = {
    SET: "SET_PRODUCT" as const,
    PATCH: "PATCH_PRODUCT" as const,
    CLEAR: "CLEAR_PRODUCT" as const,
    GENERATE_QUANTITY_ON_HAND_ADJUSTMENT: "GENERATE_QUANTITY_ON_HAND_ADJUSTMENT" as const,
    SET_INVENTORY_DATA: "SET_INVENTORY_DATA_PRODUCT" as const,
}

export type Actions =
    | { type: typeof ACTION_TYPES.SET, payload: ProductDto }
    | { type: typeof ACTION_TYPES.PATCH, payload: Partial<ProductDtoAttributes> }
    | { type: typeof ACTION_TYPES.CLEAR }
    | { type: typeof ACTION_TYPES.GENERATE_QUANTITY_ON_HAND_ADJUSTMENT }
    | { type: typeof ACTION_TYPES.SET_INVENTORY_DATA, payload: InventoryData }


// WEBPACK FOOTER //
// ./src/state/product/actions/types.ts